/**
 * sticky-header.js
 *
 * Link: https://medium.com/@mariusc23/hide-header-on-scroll-down-show-on-scroll-up-67bbaae9a78c
 *
 */

(function($) {
	var $site = $('.site'),
			$header = $('.site-header');

	var didScroll = false,
			lastScrollTop = 0,
			delta = 5,
			headerHeight = $header.outerHeight(),
			// headerHeight = 500,
			siteActiveClassName = 'has-sticky-header',
			headerActiveClassName = 'is-sticky',
			headerInactiveClassName = 'is-not-sticky';

	// on scroll, let the interval function know the user has scrolled
	$(window).scroll(function(event){
	  didScroll = true;
	});

	// run hasScrolled() and reset didScroll status
	setInterval(function() {
	  if (didScroll) {
	    hasScrolled();
	    didScroll = false;
	  }
	}, 250);

	function hasScrolled() {
		var st = $(this).scrollTop();

		if ( Math.abs(lastScrollTop - st) <= delta )
  		return;

  	// If current position > last position AND scrolled past navbar...
		if ( st > lastScrollTop && st > headerHeight ){
		  // Scroll Down

		  // Remove 'is-top' class if scroll past headerHeight * 2
		  // if ( st > ( headerHeight * 2 ) ) 
			$site.removeClass('is-top'); 

			// Toggle active sticky header classes
		  // $header.removeClass(headerActiveClassName).addClass(headerInactiveClassName);
		} else {
		  // Scroll Up

		  // If did not scroll past the document (possible on mac)...
		  if( st + $(window).height() < $(document).height() ) { 
		  	// Add 'is-top' class if scrolled to the top
		  	if ( st < 1 ) {
		  		$site.addClass('is-top');
		  	}

				// Toggle active sticky header classes
		    $header.addClass(headerActiveClassName).removeClass(headerInactiveClassName);
		  }
		}

	  lastScrollTop = st;
	}

})(jQuery);